/*
 * Special-Navi und Breadcrumb
 */
/**
 * @namespace Breadcrumbnavigation
 */
SWR.Breadcrumbnavigation = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'breadcrumbnavigation';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.breadcrumb'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Breadcrumbnavigation = function () {
    function Breadcrumbnavigation(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      // FIX
      if (!self.$element.parent().is('nav')) {
        self.$element.wrap('<nav class="breadcrumb-wrap" />');
      }
      self.element = self.$element.parent()[0];
      self.$element = self.$element.parent();

      var slider = document.querySelector(".breadcrumb");
      var isDown = false;
      var startX;
      var scrollToLeft;

      //initiales scrollen nach aussen
      var mq = window.matchMedia("screen and (max-width:768px)");
      if (mq.matches) {
        slider.scrollLeft = 10000;
      }

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollToLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return; // stop the fn from running
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        var walk = (x - startX) * 3;
        slider.scrollLeft = scrollToLeft - walk;
      });
    }

    // public
    Breadcrumbnavigation.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Breadcrumbnavigation._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Breadcrumbnavigation(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Breadcrumbnavigation;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Breadcrumbnavigation._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Breadcrumbnavigation._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Breadcrumbnavigation._jQueryInterface;
  $.fn[NAME].Constructor = Breadcrumbnavigation;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Breadcrumbnavigation._jQueryInterface;
  };

  return Breadcrumbnavigation;

}(window.jQuery);

